import { type EmojiCategory, type EmojiCollection, type EmojiCollectionData } from '@pkg/hooks';

export function assertAllResults(category?: EmojiCategory, keywordFilter?: string): category is undefined {
    return Boolean(keywordFilter || !category);
}

export function collectItems(collection?: EmojiCollection, category?: EmojiCategory) {
    if (!collection) return [];
    return category ? collection[category] ?? [] : Object.values(collection).flat();
}

export function filterItems(items: EmojiCollectionData[], keyword?: string) {
    // TODO: Should also include `aliases` once
    // that is supported within `EmojiCollectionData`.
    return keyword
        ? items.filter(
              ({ glyph, name, shortName }) =>
                  glyph.includes(keyword) || name.includes(keyword) || shortName.includes(keyword),
          )
        : items;
}
